<template>
  <div>
    <base-drawer title="Editar assinatura" :open="open" :close="close" @onClose="resetDrawers">
      <base-tabs :tabs="tabs" @change="changeTab" />
      <div v-if="activeTab == 'PAGAMENTO'">
        <div class="mb_20" @click="drawers.newCard.open = !drawers.newCard.open">
          <base-add text="ADICIONAR CARTÃO" :plus="false" height="100px" />
        </div>
        <div v-for="(cardItem, cardIndex) in cards" :key="`card-${cardIndex}`" class="mb_20">
          <base-card>
            <div class="card-item">
              <div class="brand mr_20">
                <div class="no-brand"></div>
              </div>
              <div class="number">
                <div class="title mb_10">Cartão de crédito</div>
                <div class="card-number">{{cardItem.brand}} **** {{cardItem.finalNumber}}</div>
              </div>
              <div class="change-card">
                <base-button
                  v-if="mode == drawerMode.SELECT"
                  text="SELECIONAR"
                  @click="changeCard(cardItem)"
                  @contextmenu.prevent="changeCard(false)"
                />
                <base-button
                  v-else-if="mode == drawerMode.DELETE"
                  text="REMOVER"
                />
              </div>
            </div>
          </base-card>
        </div>
        <div class="d-flex align-center justify-center">
          <base-button
            v-if="mode == drawerMode.SELECT"
            text="REMOVER CARTÃO"
            @click="mode = drawerMode.DELETE"
          />
          <base-button
            v-else-if="mode == drawerMode.DELETE"
            design="four"
            text="CANCELAR"
            @click="mode = drawerMode.SELECT"
          />
        </div>
      </div>
      <div v-else>
        <base-card>
          <div class="modules-header d-flex">
            <div class="modules-title flex">
              Módulos ativos
            </div>
            <div class="modules-actions pb_25">
              <base-button v-if="modulesMode == drawerMode.SELECT" design="four"  text="EDITAR" @click="modulesMode = drawerMode.DELETE" class="p_0" />
              <base-button v-else design="four"  text="CANCELAR" @click="modulesMode = drawerMode.SELECT" class="p_0" />
            </div>
          </div>
          <div>
            <div
              v-for="(moduleItem, moduleIndex) in modules"
              :key="`module-${moduleIndex}`"
              class="py_20 module-item"
            >
              <div class="d-flex align-center">
                <div class="flex">
                  <p class="module-name mb_10">{{moduleItem.name}}</p>
                  <p class="module-since">ATIVO DESDE {{moduleItem.start_date}}</p>
                </div>
                <base-button
                  v-if="modulesMode == drawerMode.DELETE"
                  text="REMOVER"
                  class="p_0"
                  @click="selectModuleToRemove(moduleItem)"
                />
                <p v-else class="module-price">R$ {{moduleItem.price}}</p>
              </div>
            </div>
          </div>
          <p class="modules-total text-right mt_30">
            <span>total</span>
            R$ {{calculateModulesTotal()}}
          </p>
        </base-card>
      </div>
    </base-drawer>
    <div class="new-card-wrapper">
      <base-drawer
        :open="drawers.newCard.open"
        :close="drawers.newCard.close"
        title="Cadastrar Cartão"
      >
        <base-card>
          <div class="card-template pb_50 pt_30 px_35">
            <div class="brand d-flex justify-end mb_25">
              <div class="no-brand"></div>
            </div>
            <div class="card-number mb_30">{{card.number || '0000 0000 0000 0000'}}</div>
            <div class="row">
              <div class="card-name col-xs-6">
                <p class="label mb_5">TITULAR DO CARTÃO</p>
                <p class="content">{{card.name || `Titular do cartão`}}</p>
              </div>
              <div class="card-expire col-xs-6">
                <p class="label mb_5">DATA DE VALIDADE</p>
                <p class="content">{{card.expireDate || '01/01'}}</p>
              </div>
            </div>
          </div>
          <div class="px_25 py_30">
            <base-input label="Titular do cartão" v-model="card.name" />
            <base-input
              label="Número do cartão"
              v-model="card.number"
              mask="#### #### #### ####"
              masked
            />
            <div class="row mb_30">
              <base-input
                label="Data de validade"
                class="col-xs-6"
                v-model="card.expireDate"
                mask="##/##"
              />
              <base-input label="Cod. de Segurança" class="col-xs-6" v-model="card.cvc" mask="###" />
            </div>
            <div>
              <base-button text="ADICIONAR CARTÃO" @click="addCard" class="w-100" />
            </div>
          </div>
        </base-card>
        <div class="d-flex align-center justify-center">
          <base-button
            design="four"
            text="CANCELAR CADASTRO"
            @click.prevent="closeNewDrawer"
          />
        </div>
      </base-drawer>
    </div>
    <div class="remove-module">
      <base-drawer
        :open="drawers.removeModule.open"
        :close="drawers.removeModule.close"
        @onClose="unselectModule()"
        title="Remover módulo"
      >
        <div v-if="!drawers.removeModule.confirmed" class="remove_module_warning">
          <warning-update-subscription
            @confirm="removeModule"
            @closeDrawer="unselectModule"
          />
        </div>
        <div v-else class="remove_module_success">
          <success-update-subscription
            @close="closeMe"
          />
        </div>
      </base-drawer>
    </div>
    <div class="change-card">
      <base-drawer
        :open="drawers.changeCard.open"
        :close="drawers.changeCard.close"
        @onClose="unselectModule"
        :title="getChangeCardTitle()"
      >
        <div v-if="drawers.changeCard.validating" class="validating-card">
            <validate-card />
        </div>
        <div v-else>
          <div v-if="drawers.changeCard.success" class="validating-success-card">
            <success-card @close="closeMe" />
          </div>
          <div v-else class="validating-error-card">
            <error-card @close="closeMe" />
          </div>
        </div>
      </base-drawer>
    </div>
  </div>
</template>
<script>

import jsonModules from "@/api/myModules.json";
import jsonCards from "@/api/cards.json";
import BaseTabs from "@/components/Tabs";
import BaseDrawer from "@/components/Drawer";
import BaseButton from "@/components/Button";
import BaseBox from "@/components/Box";
import BaseAdd from "@/components/Add";
import BaseCard from "@/components/Card";
import BaseInput from "@/components/Input";
import WarningUpdateSubscription from "@/containers/Account/UpdateSubscription/Warning.vue";
import SuccessUpdateSubscription from "@/containers/Account/UpdateSubscription/Success.vue";

import ValidateCard from "@/containers/Account/Card/Validate.vue";
import SuccessCard from "@/containers/Account/Card/Success.vue";
import ErrorCard from "@/containers/Account/Card/Error.vue";

const drawerMode = {
  SELECT: "select",
  DELETE: "delete"
};

const tabs = [
  { name: "Pagamento", value: "PAGAMENTO" },
  { name: "Módulos", value: "MODULOS" }
];

export default {
  components: {
    BaseDrawer,
    BaseButton,
    BaseBox,
    BaseTabs,
    BaseAdd,
    BaseCard,
    BaseInput,
    WarningUpdateSubscription,
    SuccessUpdateSubscription,
    ValidateCard,
    SuccessCard,
    ErrorCard
  },
  props: {
    open: false,
    close: false
  },
  data() {
    return {
      tabs,
      activeTab: "PAGAMENTO",
      cards: [],
      modules: [],
      drawerMode,
      mode: drawerMode.SELECT,
      modulesMode: drawerMode.SELECT,
      selectedToRemove: null,
      drawers: {
        newCard: { open: false, close: false },
        removeModule: {
          open: false,
          confirmed: false,
          close: false
        },
        changeCard: {
          open: false,
          close: false,
          success: false,
          validating: false
        }
      },
      card: {
        name: "",
        number: "",
        cvc: "",
        expireDate: ""
      }
    };
  },
  watch: {
    close() {
      this.resetDrawers();
    }
  },
  mounted() {
    this.cards = jsonCards;
    this.modules = jsonModules;
  },
  methods: {
    closeMe() {
      this.resetDrawers();
      this.$emit('close');
    },
    resetDrawers() {
      this.drawers.changeCard.close = !this.drawers.changeCard.close;
      console.log(this.drawers.changeCard.close);

      this.$nextTick(() => {
        this.modulesMode = drawerMode.SELECT;
        this.mode = drawerMode.SELECT;
        this.drawers.changeCard.validating = false;
        this.drawers.changeCard.success = false;
      })

      this.unselectModule();
    },
    addCard() {
      this.drawers.newCard.close = !this.drawers.newCard.close;
      this.$emit("onCardAdded", JSON.parse(JSON.stringify(this.card)));
    },
    closeNewDrawer() {
      this.drawers.newCard.close = !this.drawers.newCard.close;
    },
    changeTab(tab) {
      this.activeTab = tab;
    },
    calculateModulesTotal() {
      return this.modules.reduce((c, m) => c + m.price, 0);
    },
    selectModuleToRemove(module) {
      this.selectedToRemove = module;
      this.drawers.removeModule.open = !this.drawers.removeModule.open;
      this.drawers.removeModule.confirmed = false;
    },
    unselectModule() {
      this.drawers.removeModule.close = !this.drawers.removeModule.close;
      this.$nextTick(() => {
        this.drawers.removeModule.confirmed = false;
        this.selectedToRemove = null;
      })
    },
    removeModule() {
      this.drawers.removeModule.confirmed = true;
    },
    changeCard(cardItem) {
      this.drawers.changeCard.validating = true;
      this.drawers.changeCard.open = !this.drawers.changeCard.open;
      setTimeout(() => {
        this.drawers.changeCard.validating = false;
        this.drawers.changeCard.success = !!cardItem;
      }, 5000)
    },
    getChangeCardTitle() {
        if(this.drawers.changeCard.validating) {
          return 'Validação do cartão';
        } else if(this.drawers.changeCard.success) {
          return 'Pagamento realizado';
        } else {
          return 'Erro com pagamento';
        }
    }
  }
};
</script>
<style scoped>
.card-item .brand .no-brand {
  width: 50px;
  height: 35px;
  background: #eeeeee 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.card-item {
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.card-item .number {
  flex: 1;
}

.card-item .number .title {
  text-align: left;
  font: normal normal normal 15px/18px Lato;
  letter-spacing: 0px;
  color: #aaaaaa;
  opacity: 1;
}

.card-item .number .card-number {
  text-align: left;
  font: normal normal normal 12px/15px Lato;
  letter-spacing: 0px;
  color: #bbbbbb;
  opacity: 1;
}

.card-item .change-card {
  display: flex;
  align-items: center;
}

.new-card-wrapper .card {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
}

.new-card-wrapper .brand .no-brand {
  width: 50px;
  height: 35px;
  background: #0099ff 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.new-card-wrapper .card-number {
  text-align: left;
  font: normal normal 900 22px/27px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
}

.new-card-wrapper .card-name .label,
.new-card-wrapper .card-expire .label {
  text-align: left;
  font: normal normal bold 10px/12px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
}

.new-card-wrapper .card-name .content,
.new-card-wrapper .card-expire .content {
  text-align: left;
  font: normal normal 300 16px/19px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
}

.module-name {
  text-align: left;
  font: normal normal 300 16px/19px Lato;
  letter-spacing: 0px;
  color: #bbbbbb;
  opacity: 1;
}

.module-since {
  text-align: left;
  font: normal normal bold 12px/15px Lato;
  letter-spacing: 0px;
  color: #dddddd;
  opacity: 1;
}

.module-price {
  text-align: left;
  font: normal normal 300 16px/19px Lato;
  letter-spacing: 0px;
  color: #bbbbbb;
  opacity: 1;
}

.module-item {
  border-top: 0.2px solid #99999955;
}

.module-item:last-child {
  border-bottom: 0.2px solid #99999955;
}

.modules-total span {
  font: normal normal 300 16px/19px Lato;
  letter-spacing: 0px;
  color: #bbbbbb;
}

.modules-total {
  font: normal normal bold 18px/22px Lato;
  letter-spacing: 0px;
  color: #bbbbbb;
}

.modules-title {
  font: normal normal bold 16px/19px Lato;
  letter-spacing: 0px;
  color: #0099FFCC;
}
</style>